import { css } from "styled-components";
import { MixinIcon, MixinIconReversable, MixinSquareIcon } from "../common";
export const riotProductSkin = (chroma, paletteTokens) => css `
  &.icon-link {
    ${MixinIcon({ icon: chroma.icons.link, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
    /* Link icons need to adapt to text sizes */
    width: 1em;
    height: 1em;
  }

  /* Same-size small icons */
  &.icon-x,
  &.icon-facebook,
  &.icon-discord,
  &.icon-instagram,
  &.icon-share,
  &.icon-twitch,
  &.icon-vk,
  &.icon-youtube,
  &.icon-line,
  &.icon-reddit,
  &.icon-accordionPlus,
  &.icon-accordionMinus,
  &.icon-arrowRight,
  &.icon-arrowLeft,
  &.icon-close,
  &.icon-search,
  &.icon-platformWindows,
  &.icon-platformMac,
  &.icon-platformIos,
  &.icon-platformAndroid,
  &.icon-platformPC,
  &.icon-platformPSN,
  &.icon-platformXbox {
    width: 24px;
    height: 24px;
  }

  &.icon-linkUrl {
    ${MixinIcon({ icon: chroma.icons.linkUrl, color: paletteTokens.bladetext1 })};
    width: 24px;
    height: 14px;
  }

  &.icon-checkmark {
    ${MixinIcon({ icon: chroma.icons.checkmark, color: paletteTokens.bladetext1 })};
    width: 20px;
    height: 16px;
  }

  &.icon-media {
    ${MixinIcon({ icon: chroma.icons.media, color: paletteTokens.bladetext1 })};
  }

  &.icon-action-external-link {
    ${MixinSquareIcon({ icon: chroma.icons.linkSquare })};
  }

  &.icon-plus {
    ${MixinIcon({ icon: chroma.icons.plus, color: paletteTokens.bladetext1 })};
  }

  &.icon-action-image-viewer {
    ${MixinSquareIcon({ icon: chroma.icons.mediaSquare })};
  }

  &.icon-action-play-video {
    ${MixinSquareIcon({ icon: chroma.icons.playerSquare })};
    height: 110px;
    width: 110px;
    display: inline-block;
  }

  &.icon-action-download {
    ${MixinSquareIcon({ icon: chroma.icons.downloadSquare })};
    height: 110px;
    width: 110px;
    display: inline-block;
  }

  &.icon-download {
    width: 24px;
    height: 24px;
    ${MixinIcon({ icon: chroma.icons.download, color: paletteTokens.bladetext_ulc })};
  }

  &.icon-accordionPlus {
    ${MixinIcon({ icon: chroma.icons.accordionPlus, color: paletteTokens.bladetext1 })};
  }

  &.icon-accordionMinus {
    ${MixinIcon({ icon: chroma.icons.accordionMinus, color: paletteTokens.bladetext1 })};
  }

  &.icon-arrowRight {
    width: 54px;
    height: 22px;
    ${MixinIcon({ icon: chroma.icons.arrowRight, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-arrowLeft {
    width: 54px;
    height: 22px;
    ${MixinIcon({ icon: chroma.icons.arrowLeft, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-carouselRight {
    width: 32px;
    height: 32px;
    ${MixinIcon({ icon: chroma.icons.carouselRight, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-carouselLeft {
    width: 32px;
    height: 32px;
    ${MixinIcon({ icon: chroma.icons.carouselLeft, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-dropdown {
    ${MixinIcon({ icon: chroma.icons.dropdown, color: paletteTokens.bladetext1 })};
    width: 16px;
    height: 16px;
  }

  &.icon-search {
    ${MixinIcon({ icon: chroma.icons.search, color: paletteTokens.bladetext1 })};
  }

  &.icon-close {
    ${MixinIcon({ icon: chroma.icons.close, color: paletteTokens.bladetext1 })};
    width: 24px;
    height: 24px;
  }

  &.icon-platformWindows {
    ${MixinIcon({ icon: chroma.icons.platformWindows, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformMac {
    ${MixinIcon({ icon: chroma.icons.platformMac, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformIos {
    ${MixinIcon({ icon: chroma.icons.platformIos, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformAndroid {
    ${MixinIcon({ icon: chroma.icons.platformAndroid, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformPC {
    ${MixinIcon({ icon: chroma.icons.platformPC, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformPSN {
    ${MixinIcon({ icon: chroma.icons.platformPSN, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformXbox {
    ${MixinIcon({ icon: chroma.icons.platformXbox, color: paletteTokens.bladetext1 })};
  }

  &.icon-x {
    ${MixinIcon({ icon: chroma.icons.x, color: paletteTokens.bladetext1 })};
  }

  &.icon-facebook {
    ${MixinIcon({ icon: chroma.icons.facebook, color: paletteTokens.bladetext1 })};
  }

  &.icon-discord {
    ${MixinIcon({ icon: chroma.icons.discord, color: paletteTokens.bladetext1 })};
  }

  &.icon-instagram {
    ${MixinIcon({ icon: chroma.icons.instagram, color: paletteTokens.bladetext1 })};
  }

  &.icon-share {
    ${MixinIcon({ icon: chroma.icons.share, color: paletteTokens.bladetext1 })};
  }

  &.icon-twitch {
    ${MixinIcon({ icon: chroma.icons.twitch, color: paletteTokens.bladetext1 })};
  }

  &.icon-vk {
    ${MixinIcon({ icon: chroma.icons.vk, color: paletteTokens.bladetext1 })};
  }

  &.icon-youtube {
    ${MixinIcon({ icon: chroma.icons.youtube, color: paletteTokens.bladetext1 })};
  }

  &.icon-line {
    ${MixinIcon({ icon: chroma.icons.line, color: paletteTokens.bladetext1 })};
  }

  &.icon-reddit {
    ${MixinIcon({ icon: chroma.icons.reddit, color: paletteTokens.bladetext1 })};
  }

  &.icon-playstation {
    ${MixinIcon({ icon: chroma.icons.playstation, color: paletteTokens.bladetext1 })};
    width: 22px;
    height: 16px;
  }

  &.icon-xbox {
    ${MixinIcon({ icon: chroma.icons.xbox, color: paletteTokens.bladetext1 })};
    width: 24px;
    height: 24px;
  }

  &.icon-assassin {
    ${MixinIcon({ icon: chroma.icons.roleAssassin, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-controller {
    ${MixinIcon({ icon: chroma.icons.roleController, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-duelist {
    ${MixinIcon({ icon: chroma.icons.roleDuelist, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-fighter {
    ${MixinIcon({ icon: chroma.icons.roleFighter, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-initiator {
    ${MixinIcon({ icon: chroma.icons.roleInitiator, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-mage {
    ${MixinIcon({ icon: chroma.icons.roleMage, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-marksman {
    ${MixinIcon({ icon: chroma.icons.roleMarksman, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-sentinel {
    ${MixinIcon({ icon: chroma.icons.roleSentinel, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-support {
    ${MixinIcon({ icon: chroma.icons.roleSupport, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-tank {
    ${MixinIcon({ icon: chroma.icons.roleTank, color: paletteTokens.accents1 })};
    height: 32px;
    width: 32px;
  }

  &.icon-difficulty-1 {
    ${MixinIcon({ icon: chroma.icons.difficultyLow, color: paletteTokens.accents1 })};
    height: 32px;
    width: 48px;
  }

  &.icon-difficulty-2 {
    ${MixinIcon({ icon: chroma.icons.difficultyMed, color: paletteTokens.accents1 })};
    height: 32px;
    width: 48px;
  }

  &.icon-difficulty-3 {
    ${MixinIcon({ icon: chroma.icons.difficultyHigh, color: paletteTokens.accents1 })};
    height: 32px;
    width: 48px;
  }

  &.icon-marqueeArrowRight {
    width: 40px;
    height: 55px;
    ${chroma.mediaQueries.tabletDown} {
      height: 32px;
      width: 24px;
    }

    ${MixinIcon({ icon: chroma.icons.marqueeArrowRight, color: paletteTokens.bladetext1 })};
  }

  &.icon-divider {
    ${MixinIcon({ icon: chroma.icons.divider, color: paletteTokens.accents1 })};
    width: auto;
    height: 100%;
    mask-size: contain;
  }

  &.icon-square {
    ${MixinIcon({ icon: chroma.icons.square, color: paletteTokens.bladetext1 })};
    aspect-ratio: 1;
  }
`;
//# sourceMappingURL=index.js.map